export default __webpack_public_path__ + "304968951609b6d4ee02e9d68aa64058.gif";